module.exports = __webpack_public_path__ + "img/yellow-ribbon.b903200c.svg";